<template>
  <div v-if='loading'>
    <oil-cap
        title='ДОВЕРЕННОСТИ'
        :buttons="[
        {
          route: 'procuration-create',
          name: 'Добавить Доверенность'.toUpperCase()
        }
      ]"
        service-name="empowerment"
        :search-filter='onSearchValueChange'
    />
    <v-divider class="my-2"/>
    <oil-table
        :hide-footer="true"
        :item-counts="empowerments.length+1"
        :keys="[
        {
          text: 'Покупатель'.toUpperCase(),
          value: 'CompanyName'
        },
        {
          text: 'ИНН'.toUpperCase(),
          value: 'VatNo'
        },
        {
          text: 'Доверенность'.toUpperCase(),
          value: 'Number'
        },
        {
          text: 'Статус'.toUpperCase(),
          value: 'Status'
        }
        ,
        {
          text: '',
          value: 'Id'
        }
        ,
        {
          text: '',
          value: 'DeleteId'
        }
      ]"
        :paginate='count'
        @paginateAction='paginate'
        :items='empowerments'
    >
      <template v-slot:Id='{value}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-bind='attrs'
                   v-on='on' icon
                   @click.stop='handleRowClick(value)'>
              <v-icon color='primary'>
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>

      <template v-slot:DeleteId='{value}'>
        <v-row>
          <v-col
              md='4'
              offset-md='4'
          >

            <oil-modal
                :value='value'
                tooltipMessage='УДАЛИТЬ'
                mdiIcon='mdi-delete'
                :accept='deleteEmpowerment'
            />

          </v-col>
        </v-row>

      </template>

    </oil-table>
  </div>
</template>

<script>
import {empowermentService} from '@/services/EmpowermentService'
import {contractsService} from '@/services/ContractsService'
import {coreApi} from '~/services/core'

export default {
  components: {
    OilTable: () => import('@/components/helper/oil.table.vue'),
    OilCap: () => import('@/components/helper/oil.cap'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal')
  },
  data: () => ({
    loading: false,
    empowerments: [],
    count: {
      count: 0
    },
    status: {
      active: 'Активный',
      draft: 'Неподписанный',
      special: 'Особый',
      inactive: 'Неактивный'
    },
  }),
  async created() {
    await this.paginate((this.currentPage - 1) * 10)
    this.loading = true
  },
  methods: {
    handleRowClick(Id) {
      this.$router.push(`procuration/${Id}`)
    },
    async deleteEmpowerment(id) {
      const response = await empowermentService.delete(id)
      const isDelete = response.data
      if (isDelete) {
        const empowerment = this.empowerments.find(({Id}) => Id === id)
        const index = this.empowerments.indexOf(empowerment)
        this.empowerments.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `Договор под номером ${empowerment.Number} удачно удален`
        })
      }
    },
    async paginate(page) {
      const empowerments = await empowermentService.paginate(page)
      const {count, dates} = empowerments.data
      this.count.count = count
      this.empowerments = dates?.map(empowerment => {
        return {
          Id: empowerment?.Id,
          DeleteId: empowerment?.Id,
          CompanyName: empowerment?.Company?.CompanyName,
          Number: empowerment?.Number,
          Status: this.status[empowerment?.Status],
          VatNo: empowerment?.Company?.TaxNo
        }
      }) || []
    },
    async onSearchValueChange(data) {
      if (!data) {
        await this.paginate((this.currentPage - 1) * 10)
        return
      }
      this.empowerments = data?.map(empowerment => {
        return {
          Id: empowerment?.Id,
          DeleteId: empowerment?.Id,
          CompanyName: empowerment?.Company?.CompanyName,
          Number: empowerment?.Number,
          Status: this.status[empowerment?.Status],
          VatNo: empowerment?.Company?.TaxNo
        }
      })
    }
  }
}
</script>